export default DataTable;

import AjaxRequest from './Ajax';

const $ = jQuery;


function DataTable(config) {
    const SETTLEMENT_STATISTIC = 'settlement_statistic';
    const ELECTION = 'election';
    var paginationSelector;
    var paginationSelector2;
    var searchBtnSelector;
    var filterSelectSelector;
    var searchInputSelector;
    var pageNumber;
    var totalCount;
    var status = 'closed';
    var activeElectionKey = 'newest';
    var activePartyKey = 'all';
    init();

    function init() {
        paginationSelector = config.dataSheetConfig.domElements.dataTablePaginationId + config.type;
        paginationSelector2 = config.dataSheetConfig.domElements.dataTablePaginationId2 + config.type;
        searchBtnSelector = config.dataSheetConfig.domElements.dataTableSearchBtnId + config.type;
        searchInputSelector = config.dataSheetConfig.domElements.dataTableSearchInputId + config.type;
        filterSelectSelector = config.dataSheetConfig.domElements.dataTableFilterSelect;
        render(1);
        //console.log(config.objectType);
    }
 
    function setPagerButtons(result) {
        //values
        const columnCount = result.columnCount;
        const columnLimit = result.columnLimit;
        const pageNumber = result.pageNumber;
        const resultLength = result.columns.length - 1;
        const isFirstPage = pageNumber === 1;
        const isLastPage = pageNumber >= Math.ceil(columnCount / columnLimit);
        const previousButton = isFirstPage ? '&nbsp;' : `<span class="previous-button" data-num="${pageNumber - 1}">« vissza</span>`
        const nextButton = isLastPage ? '&nbsp;' : `<span class="next-button" data-num="${pageNumber + 1}">előre »</span>`
        const emptyTh = '<th>&nbsp;</th>';

        //elements
        const statisticContainer = $('.dataTableContainer .settlement-statistic');
        const headersContainer = statisticContainer.find('th').parent('tr');

        //add content
        headersContainer.before($(`<!--
            <tr class="table-pager">
                <th>&nbsp;</th>
                <th>${previousButton}</th>
                 ${emptyTh.repeat(resultLength - 2)}
                <th>${nextButton}</th>
            </tr>-->`
            )
        );

        //events
        if (isFirstPage === false) {
            statisticContainer.find('.previous-button').on('click', stepPage);
        }

        if (isLastPage === false) {
            statisticContainer.find('.next-button').on('click', stepPage);
        }

    }

    function stepPage(e) {
        e.preventDefault();
        const page = e.target.getAttribute('data-num');
        render(page);
    }

    function initEvents() {
        $(config.dataSheetConfig.domElements.dataTableWrapper).find('.nnp-toggle-element').off('click');
        $(config.dataSheetConfig.domElements.dataTableWrapper).find('.nnp-toggle-element').on('click', function (event) {
            var wrapperId = $(event.currentTarget).closest('.nnpDataTableWrapper').attr('id');
            if (wrapperId !== undefined) {
                toggleElement($(event.currentTarget));
            }
        });
        $(config.dataSheetConfig.domElements.dataTableWrapper + ' th').off('click');
        $(config.dataSheetConfig.domElements.dataTableWrapper + ' th').on('click', (event) => {
            var currentHeader = event.currentTarget.id;
            if (currentHeader !== '') {
                var table = document.getElementById(currentHeader).closest('table');
                sortTable(currentHeader, table);
            }
        });
        if (config.type === SETTLEMENT_STATISTIC) searchBtnEvents();
        if (config.type === ELECTION) filterSelectEvents();
    }

    function toggleElement(selector) {
        if (selector.hasClass('closed')) {
            selector.removeClass('closed');
            selector.addClass('open');
        } else {
            selector.removeClass('open');
            selector.addClass('closed');
        }
    }

    function render(page) {
        pageNumber = page;
        var search = $(searchInputSelector).val();
        getData((result) => {
            if (result !== null && result.data.length) {
                setDataTableStatus();
                var template = Handlebars.compile($(config.dataSheetConfig.templates.dataTableBlock).html());
                var html = template({
                    title: config.title,
                    result: result.data,
                    fieldNameList: result.columns,
                    type: config.type,
                    searchInput: search,
                    status: status,
                });

                if (config.type === ELECTION || page > 1 || search !== undefined) {
                    $(config.selector).html(html);
                    //átvezettem a template-be
                    //$(config.selector).find('.nnpDataTableWrapper').addClass('table-election');
                } else {
                    $(config.selector).append(html);
                }

                if (config.type === SETTLEMENT_STATISTIC) {
                    totalCount = result.columnCount;
                    pageNumber = result.pageNumber;
                    addPagination();
                    setPagerButtons(result);
                }

                if (config.type === ELECTION) addElectionFilters(result);

                initEvents();
            } else {
                destroy();
            }
        });
    }


    function destroy() {
        $(config.selector).html('');
    }

    function addElectionFilters(feed) {
        const {electionList, partyList} = feed;
        let html = '';
            if (config.objectType === 'geo') html += createSelect('electionList', electionList);
            if (config.objectType === 'geo') html += createSelect('partyList', partyList);
            $(config.dataSheetConfig.domElements.dataTableElectionFilterContainer).append(html);
    }

    function createSelect(type, feed) {
        let activeOption = -1;
        let html = '<select id="' + type + '" name="' + type + '" class="nnp-datasheet-datatable-select">';

        feed.forEach(item => {
            if (item.active) {
                activeOption = item.key;
            }
        });

        if (type === 'partyList') html += '<option value="-1" ' + (activeOption === -1 ? 'selected>' : '>') +
            'Összes Párt</option>';
        feed.forEach(item => {
            html += '<option value="' + item.key + '" ' + (item.key === activeOption ? 'selected>' : '>') + item.title +
                '</option>';
        });
        html += '</select>';

        return html;
    }

    function setDataTableStatus() {
        var $dataTable = $(config.selector).find('.nnpDataTableWrapper').find('.nnp-toggle-element');
        if ($dataTable.length > 0) {
            if ($dataTable.hasClass('open')) {
                status = 'open';
            } else {
                status = 'closed';
            }
        }
    }

    function sortTable(header, table) {
        const th = document.getElementById(header);
        const getCellValue = (tr, idx) => tr.children[idx].innerText || tr.children[idx].textContent;
        const comparer = (idx, asc) => (a, b) => ((v1, v2) =>
                v1 !== '' && v2 !== '' && !isNaN(v1) && !isNaN(v2) ? v1 - v2 : v1.toString().localeCompare(v2)
        )(getCellValue(asc ? a : b, idx), getCellValue(asc ? b : a, idx));

        //az extra lapozó miatt szükséges
        const nPlus = header.match(/settlement/) ? 3 : 2;

        Array.from(table.querySelectorAll(`tr:nth-child(n+${nPlus})`)).sort(comparer(Array.from(th.parentNode.children).indexOf(th), th.asc = !th.asc)).forEach(tr => table.children[0].appendChild(tr));
        changeSortedClass(table, th);
    }

    function changeSortedClass(table, th) {
        table.querySelectorAll('tr th').forEach((item) => {
            item.classList = [];
        });

        if (th.asc) {
            th.classList.add('sorted_asc');
        } else {
            th.classList.add('sorted_desc');
        }
    }

    function addPagination() {
        $(paginationSelector).pagination({
            dataSource: (done) => {
                var result = [];
                for (var i = 1; i < totalCount; i++) {
                    result.push(i);
                }
                done(result);
            },
            pageSize: config.columnLimit,
            pageRange: 5,
            pageNumber: pageNumber,
            callback: function (data, pagination) {
                paginationEvents();
            },
        });
        $(paginationSelector2).pagination({
            dataSource: (done) => {
                var result = [];
                for (var i = 1; i < totalCount; i++) {
                    result.push(i);
                }
                done(result);
            },
            pageSize: config.columnLimit,
            pageRange: 5,
            pageNumber: pageNumber,
            callback: function (data, pagination) {
                paginationEvents();
            },
        });
    }

    function paginationEvents() {
        $(paginationSelector + ' .paginationjs-pages li').on('click', (e) => {
            e.preventDefault();
            var page = e.target.innerText;
            if (page === '«') {
                page = pageNumber - 1;
            } else if (page === '»') {
                page = pageNumber + 1;
            }
            render(page);
        });
        $(paginationSelector2 + ' .paginationjs-pages li').on('click', (e) => {
            e.preventDefault();
            var page = e.target.innerText;
            if (page === '«') {
                page = pageNumber - 1;
            } else if (page === '»') {
                page = pageNumber + 1;
            }
            render(page);
        });
    }

    function filterSelectEvents() {
        $(filterSelectSelector).on('change', (e) => {
            e.preventDefault();
            if (e.target.id === 'electionList') activeElectionKey = e.target.value;
            if (e.target.id === 'partyList') activePartyKey = Number(e.target.value) === -1 ? 'all' : e.target.value;
            render(1);
        });
    }

    function searchBtnEvents() {
        $(searchBtnSelector).on('click', (e) => {
            e.preventDefault();
            render(1);
        });
        $(searchInputSelector).keydown((e) => {
            if (e.keyCode === 13) {
                e.preventDefault();
                $(searchBtnSelector).trigger('click');
                return false;
            }
        });
    }

    function getData(callback) {
        var request = {
            url: config.dataSheetConfig.ajaxUrl + '/datatable',
            data: {
                object_type: config.objectType,
                action: 'datatable',
                type: config.type,
                id: config.objectId,
            },
            success: function (response) {
                if (response.success) {
                    callback(response.data);
                }
            },
        };
        var $searchInput = $(searchInputSelector);
        if (config.type === ELECTION) {
            if (config.objectType === 'memorial') {
                return;
            } if (config.objectType !== 'person') {
                $.extend(request.data, {active_election_key: activeElectionKey})
            } else if (config.objectType !== 'corporate') {
                $.extend(request.data, {active_party_key: activePartyKey})
            }
        } else {
            if ($searchInput.val() !== undefined && $searchInput.val() !== '') {
                $.extend(request.data, {search: encodeURIComponent($searchInput.val())});
            }
            $.extend(request.data, {page_number: Number(pageNumber), column_limit: 12});
        }
        AjaxRequest(request);
    }
}